/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import {
  Breadcrumb,
  Navbar,
} from 'react-bootstrap';
import CSSModules from 'react-css-modules';
import ShowIf from '../ShowIf';
import styles from './styles.scss';

const defaultProps = {
  brandIcon: null,
  brandTitle: null,
  breadcrumb: null,
  brandTools: null,
  leftTools: null,
  rightTools: null,
};

const propTypes = {
  brandIcon: React.PropTypes.any,
  brandTitle: React.PropTypes.any,
  breadcrumb: React.PropTypes.array,
  brandTools: React.PropTypes.array,
  leftTools: React.PropTypes.array,
  rightTools: React.PropTypes.array,
};

class Toolbar extends React.Component {

  static renderTools(tools, pullRight = false) {
    if (tools) {
      const toolComs = tools.map((t, idx) => {
        if (t.type === 'buttons') {
          return (
            <Navbar.Form
              key={String(idx)}
              pullRight={pullRight}
            >
              <ul styleName="button-list">
                {
                  t.buttons.map((b, i) => (
                    <li key={String(i)}>{b}</li>
                  ))
                }
              </ul>
            </Navbar.Form>
          );
        } else if (t.type === 'search') {
          return (
            <Navbar.Form
              key={String(idx)}
              pullRight={pullRight}
            >
              {t.searchInput}
            </Navbar.Form>
          );
        } else if (t.type === 'selectpills') {
          return (
            <Navbar.Form
              key={String(idx)}
              styleName="navbar-spills"
              pullRight={pullRight}
            >
              {t.selectPills}
            </Navbar.Form>
          );
        }
        return (
          <Navbar.Form
            key={String(idx)}
            styleName="navbar-input"
            pullRight={pullRight}
          >
            <span styleName="navbar-label">
              {t.label}
            </span>
            {t.input}
          </Navbar.Form>
        );
      });
      return toolComs;
    }
    return null;
  }

  constructor(props) {
    super(props);
    this.state = {
      brandIcon: this.props.brandIcon,
      brandTitle: this.props.brandTitle,
      breadcrumb: this.props.breadcrumb,
      brandTools: this.props.brandTools,
      leftTools: this.props.leftTools,
      rightTools: this.props.rightTools,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.brandIcon !== this.props.brandIcon ||
        nextProps.brandTitle !== this.props.brandTitle ||
        nextProps.breadcrumb !== this.props.breadcrumb ||
        nextProps.leftTools !== this.props.leftTools ||
        nextProps.rightTools !== this.props.rightTools ||
        nextProps.brandTools !== this.props.brandTools) {
      this.setState({
        brandIcon: nextProps.brandIcon,
        brandTitle: nextProps.brandTitle,
        brandTools: nextProps.brandTools,
        breadcrumb: nextProps.breadcrumb,
        leftTools: nextProps.leftTools,
        rightTools: nextProps.rightTools,
      });
    }
  }

  renderBrand() {
    const { brandIcon, brandTitle, brandTools, breadcrumb } = this.state;
    const brand = [];

    if (brandIcon) {
      brand.push(<span key="brand-icon" styleName="brand-icon">{brandIcon}</span>);
    }
    if (brandTitle) {
      brand.push(
        <div key="brand-title" styleName="brand-title">
          {brandTitle}
        </div>);
    }
    if (brandTools) {
      const tools = Toolbar.renderTools(brandTools);
      brand.push(...tools);
    }
    if (breadcrumb) {
      brand.push(
        <div key="breadcrumb" styleName="breadcrumb">
          <Breadcrumb>
            {
              breadcrumb.map((b, idx) => (
                <Breadcrumb.Item
                  key={idx}
                  onClick={b.onClick}
                  active={b.active}
                >
                  {b.content}
                </Breadcrumb.Item>
              ))
            }
          </Breadcrumb>
        </div>);
    }

    return brand;
  }

  render() {
    const { leftTools, rightTools } = this.state;
    return (
      <div styleName="toolbar">
        <Navbar bsStyle="aisz-white">
          <Navbar.Header>
            <Navbar.Brand>
              {this.renderBrand()}
            </Navbar.Brand>
            <ShowIf if={!_.isNil(leftTools) || !_.isNil(rightTools)}>
              <Navbar.Toggle>
                <i className="fa fa-caret-down" />
              </Navbar.Toggle>
            </ShowIf>
          </Navbar.Header>
          <ShowIf if={!_.isNil(leftTools) || !_.isNil(rightTools)}>
            <Navbar.Collapse>
              {leftTools && Toolbar.renderTools(leftTools)}
              {rightTools && Toolbar.renderTools(rightTools, true)}
            </Navbar.Collapse>
          </ShowIf>
        </Navbar>
      </div>
    );
  }
}

Toolbar.defaultProps = defaultProps;
Toolbar.propTypes = propTypes;

export default CSSModules(Toolbar, styles, { allowMultiple: true });




// WEBPACK FOOTER //
// ./src/components/Toolbar/index.jsx